export default __webpack_public_path__ + "static/media/shield-virus.ae4b18b3.svg";